import { Plus } from "lucide-react";
import React from "react";
import { useForm } from "react-hook-form";
import { Button } from "../../../../../components/ui/common/button";
import { Form } from "../../../../../components/ui/common/form";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger
} from "../../../../../components/ui/common/tooltip";
import { FormInputNumber } from "../../../../../components/ui/Input/FormInputNumber/FormInputNumber";
import { FormSelect } from "../../../../../components/ui/Input/FormSelector/FormSelect";
import { formValuesToRoute } from "../utils/chemicalRecords.utils";
import { RouteFormValues, SelectOptionList, TransportRoute } from "../types/chemicalRecords.types";

interface TransportRouteDraftProps {
  chemId: string;
  transportOptions: SelectOptionList;
  onAddRoute: (chemId: string, route: Pick<TransportRoute, "type" | "distance">) => void;
}

/** Compact inline row for adding a new transport route. */
const TransportRouteDraft: React.FC<TransportRouteDraftProps> = ({
  chemId,
  transportOptions,
  onAddRoute
}) => {
  const form = useForm<RouteFormValues>({ defaultValues: { type: "", distance: "" } });

  const handleSave = form.handleSubmit(data => {
    if (!data.type) return;
    onAddRoute(chemId, formValuesToRoute(data));
    form.reset({ type: "", distance: "" });
  });

  const isValid = form.watch("type") !== "";

  return (
    <Form {...form}>
      <div className="tw-grid tw-grid-cols-[1fr_100px_40px] tw-gap-1.5 tw-items-center [&_label]:tw-hidden [&_.tw-space-y-2]:tw-space-y-0">
        <FormSelect
          control={form.control}
          name="type"
          label=""
          options={transportOptions}
          placeholder="Transport type"
        />
        <FormInputNumber
          control={form.control}
          name="distance"
          label=""
          placeholder="Dist."
          rightContentEnable
          rightContent="km"
        />
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <Button
                variant="default"
                size="icon"
                className="tw-h-10 tw-w-10"
                disabled={!isValid}
                onClick={handleSave}
              >
                <Plus className="tw-h-3 tw-w-3" />
              </Button>
            </TooltipTrigger>
            <TooltipContent>
              <p className="tw-text-xs">Save route</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </div>
    </Form>
  );
};

export default TransportRouteDraft;
